/**
 * Zustand store backing the singleton `ConnectionDiagnosticsDialog`.
 *
 * Slice 3 wires this up at app boot via `registerConnectionDiagnosticsHandler`
 * (see `App.tsx` → `useConnectionDiagnosticsDialogBoot`). The handler simply
 * sets `args` here, which causes the React component to mount and run the
 * lazy IPC fetch.
 */

import { create } from 'zustand';
import type { ShowConnectionDiagnosticsArgs } from '../showConnectionDiagnostics';

type State = {
  open: boolean;
  args: ShowConnectionDiagnosticsArgs | null;
};

type Actions = {
  openDialog: (args: ShowConnectionDiagnosticsArgs) => void;
  closeDialog: () => void;
};

export const useDiagnosticsDialogStore = create<State & Actions>((set) => ({
  open: false,
  args: null,
  openDialog: (args) => set({ open: true, args }),
  closeDialog: () => set({ open: false, args: null }),
}));
